module.exports = __webpack_public_path__ + "static/media/pod-info-alert.b4251df1.svg";